import { Content } from 'views/components/Layout';
import React from 'react';

const EmptyLayout = ({ children, ...restProps }) => (
  <main className="cr-app bg-app" {...restProps}>
    <Content fluid>{children}</Content>
  </main>
);

export default EmptyLayout;
